/* eslint-disable */
import React, {Component} from 'react'
import DataTable from 'react-data-table-component'
import authService from "../api-authorization/AuthorizeService"
import {Button, Col, Row} from "react-bootstrap"
import Card from "./Card"
import Modal from "react-bootstrap/Modal"
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import {Collapse} from 'react-collapse';

export class ReportsTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            data: [],
            report_calculations: [],
            years: [],
            field_data: [],
            field_columns: [],
            isModalShow: false,
            isNew: false,
            isOld: false
        }
        this.checkRowReport = this.checkRowReport.bind(this)
        this.getReport = this.getReport.bind(this)
        this.deleteData = this.deleteData.bind(this)
        this.ModalSaveReport = this.ModalSaveReport.bind(this)
        this.checkType = this.checkType.bind(this)
    }

    componentDidMount() {
        this.populateReportsData();
    }

    checkType(isNew) {
        this.setState({isNew: isNew ? !this.state.isNew : false, isOld: isNew ? false : !this.state.isOld}, () => {
            document.getElementById('New').checked = this.state.isNew
            document.getElementById('Old').checked = this.state.isOld
        })

    }


    ModalSaveReport() {
        return (
            <Modal
                show={this.state.isModalShow}
                onHide={() => this.setState({isModalShow: false})}
                area-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Выберите тип отчета</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className='check'><input type='checkbox' id="New" checked={this.state.isNew}
                                                       onClick={() => this.checkType(true)}/></Col><Col>Тип 1 </Col>
                    </Row>
                    <Row><Col className='check'><input type='checkbox' id='Old' checked={this.state.isOld}
                                                       onChange={() => this.checkType(false)}/></Col><Col>Тип 2</Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                            onClick={() => this.state.isNew ? this.getReport('FormYearReport') : this.getReport('formReport')}>Сохранить</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    checkRowReport(rowId) {
        const id = this.state.report_calculations.findIndex(el => el === rowId)
        if (id >= 0)
            this.state.report_calculations.splice(id, 1)
        else
            this.setState({report_calculations: this.state.report_calculations.concat(rowId)})
    }

    getReport(type) {
        fetch(`api/report/${type}?id=`, {
            method: 'POST',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.report_calculations)
        }).then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `report.xlsx`,
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
    }

    render() {
        const modalSave = this.ModalSaveReport()
        const expand = (fieldId) => {
            let changed_field = this.state.field_data.find((field) => field.id === fieldId)
            changed_field.expand = !changed_field.expand
            this.forceUpdate()
        }

        function inner_table(row) {

            function compare(a,b) {
                if ( a[0][0].card_data.report_name < b[0][0].card_data.report_name){
                    return -1;
                }
                if ( a[0][0].card_data.report_name > b[0][0].card_data.report_name){
                    return 1;
                }
                return 0;
            }

            row.data.sort(compare)
            return (<div className='year-table'>
                <DataTable
                    data={[[]]}
                    noDataComponent=''
                    columns={row.cols}
                    customStyles={{

                        rows: {
                            style: {
                                fontSize: '0',
                                height: '0',
                                minHeight: '0px',
                                border: '0 !important'
                            }
                        },
                        cells: {
                            style: {
                                fontSize: '0',
                                height: '0',
                                border: '0 !important'
                            }
                        },
                        head: {
                            style: {
                                fontSize: '20px',
                                fontWeight: '500',
                                border: '0 !important'
                            }
                        },
                        headRow: {
                            style: {
                                border: '0 !important'
                            }
                        },
                    }}
                />
                {row.data.map((row_data) => (
                    <DataTable
                        data={row_data}
                        columns={row.cols}
                        customStyles={{
                            rows: {
                                style: {
                                    fontSize: '18px',
                                    border: '0 !important'

                                }
                            },
                            head: {
                                style: {
                                    fontSize: '0',
                                    height: 0,
                                }
                            },
                            noData: {
                                style: {
                                    height: '0',
                                    fontSize: '0'
                                }
                            }
                        }}
                    />
                ))}
            </div>)
        }
        function compare( a, b ) {
            if ( a.name[0] < b.name[0]){
                return -1;
            }
            if ( a.name[0] > b.name[0] ){
                return 1;
            }
            return 0;
        }
        this.state.field_data.sort(compare)
        return (
            <>
                <Row className='report-page-label'>Отчеты</Row>
                {modalSave}
                {this.state.field_data.map((field) => {
                    return (
                            <div id='reports-table'>
                                <button className='report-btn' onClick={() => expand(field.id)}>
                                    <Row>
                                        <Col className="label"> Наименование поля:</Col>
                                        <Col>{field.name[0]}</Col>
                                        <Col className="label">/ Площадь:</Col>
                                        <Col>{field.name[1]}</Col>
                                    </Row>
                                    <div className='field-btn-arrow' >
                                        <img src={field.expand ? arrow_up : arrow_down} className='btn-arrow'
                                             alt='arrow'/>
                                    </div>
                                </button>
                                <Collapse isOpened={field.expand}>
                                    {inner_table({data: field.data, cols: field.cols})}
                                </Collapse>
                            </div>
                    )
                })}
                <div className='sticky-button'>
                    <button className='make-report-btn' onClick={() => this.getReport('formReport')}>
                        Сформировать отчет</button>
                </div>

            </>
        )
            ;
    }

    deleteData(id) {
        this.state.data.filter((row) => row.card_data.id !== id)
        this.populateReportsData(id)
    }

    get_trees(data) {
        let calc_relations = [[]]
        let find = false
        function compare( a, b ) {
            if ( a.card_data.report_name < b.card_data.report_name){
                return -1;
            }
            if ( a.card_data.report_name > b.card_data.report_name ){
                return 1;
            }
            return 0;
        }
        data.sort(compare)
        data.map((row) => {
                if (row.prev_year && row.prev_year !== '') {
                    find = false
                    calc_relations.map((array) => {
                        if (array.includes(row.prev_year)) {
                            array.push(row.card_data.id)
                            find = true
                        } else if (array.includes(row.card_data.id)) {
                            array.push(row.prev_year)
                            find = true
                        }
                    })
                    if (find === false)
                        calc_relations.push([row.prev_year, row.card_data.id])
                } else {
                    find = false
                    calc_relations.map((array) => {
                        if (array.includes(row.card_data.id))
                            find = true
                    })
                    if (find === false)
                        calc_relations.push([row.card_data.id])
                }
            }
        )
        calc_relations.reverse().pop().reverse()
        let tree_sets = []
        calc_relations.map((cur_array, i) => {
            find = false
            calc_relations.map((check_array) => {
                if (check_array !== cur_array) {
                    find = cur_array.some((r) => check_array.includes(r))
                }
                if (find === true) {
                    calc_relations[i] = cur_array.concat(check_array)
                    calc_relations = calc_relations.filter((array) => array !== check_array && array !== cur_array)
                }
            })
            tree_sets.push(new Set(calc_relations[i]))
        })
        tree_sets = tree_sets.filter((set) => set.size !== 0)
        let trees = tree_sets.map(() => [])
        tree_sets.map(([...set], i) => {
            set.map((el) => {
                let refs
                refs = data.filter((row) => row.prev_year === el)
                refs = refs.map((row) => row.card_data.id)
                trees[i].push({el: el, refs: refs})
            })
        })
        return [trees, tree_sets]
    }

    find_ref(rows, cur_el, tree, cntr, i, last_el) {
        let ref_length = cur_el.refs.length
        if (ref_length !== 0) {
            if (cur_el.refs[cntr]) {
                if (ref_length > 1) {
                    last_el.push({el: cur_el.el, cntr: cntr})
                }
                if (rows[i]) {
                    rows[i].push(cur_el.refs[cntr])
                } else {
                    rows.push([cur_el.refs[cntr]])
                }
                cur_el = tree.find(node => node.el === cur_el.refs[cntr])
                cntr = 0
                this.find_ref(rows, cur_el, tree, cntr, i, last_el)
            } else {
                last_el = last_el.filter((r) => r.el !== cur_el.el)
                if (last_el.length === 0) {
                    return rows
                } else {
                    cur_el = tree.find((node) => node.el === last_el.at(-1).el)
                    cntr = last_el.at(-1).cntr + 1
                    this.find_ref(rows, cur_el, tree, cntr, i, last_el)
                }
            }
        } else {
            if (last_el.length === 0) {
                return rows
            } else {
                cntr = last_el.at(-1).cntr + 1
                cur_el = tree.find((node) => node.el === last_el.at(-1).el)
                i++
                this.find_ref(rows, cur_el, tree, cntr, i, last_el)
            }
        }


    }

    async populateReportsData(id=-1) {
        const response_reports = await fetch('api/calculation/list', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        })
        const reports_data = await response_reports.json()

        let data = []
        let field_names = []
        let field_data = []
        let cols = []
        let isExpand=false
        let trees
        let tree_sets
        let rows
        let tree_data
        let rows_data = []
        let years
        let one_field_data
        reports_data.map((report) => {
            let sum_other_price = 0
            for (let key in report.other_price) {
                sum_other_price = sum_other_price + report.other_price[key]
            }
            const other_price = report.other_price
            const yield_self_price = (Number(other_price.seeds) + Number(other_price.szr) + Number(other_price.yield) + Number(other_price.input)) * report.field.area + Number(report.fertilizer_sum_price)
            data.push({
                need_to_change: (report.colorState !== 0),
                prev_year: report.prevCalcId,
                field_name: report.field.name,
                area: report.field.area,
                year: report.yield_year,
                card_data: {
                    report_name: report.name,
                    area: report.field.area,
                    crop_name: report.crop.name,
                    yield: report.yield,
                    date_create: new Date(report.dateCreate).toLocaleString().slice(0,-3),
                    date_change: new Date(report.dateChange).toLocaleString().slice(0,-3),
                    id: report.id,
                    yield_price: report.yield_sum_price,
                    yield_self_price: yield_self_price
                }
            })
            if (!field_names.find((row) => (row[0] === report.field.name && row[1] === report.field.area)))
                field_names.push([report.field.name, report.field.area])
        })

        years = new Set()
        data.map((row) => {
            years.add(row.year)
        })
        years = [...years].sort()
        field_names.forEach((field, i) => {
            one_field_data = data.filter(row => (row.field_name === field[0] && row.area === field[1]));
            [trees, tree_sets] = this.get_trees(one_field_data)
            trees.map((tree, i) => {
                tree_data = one_field_data.filter((row) => tree_sets[i].has(row.card_data.id))
                if (tree_data.length !== 1) {
                    let root_el = []
                    for (let year of years) {
                        const row = tree_data.find((row) => row.year === year)
                        if (tree_data.find((row) => row.year === year)) {
                            root_el = tree.find((node) => node.el === row.card_data.id)
                            break
                        }
                    }
                    rows = [[root_el.el]]
                    if (root_el.length !== 0) {
                        this.find_ref(rows, root_el, tree, 0, 0, [])
                    }
                    rows_data.push(rows.map((row) => row.map((el) => one_field_data.find((row) => row.card_data.id === el))))
                } else {
                    rows = [...tree_sets[i]]
                    rows_data.push(rows.map((el) => [one_field_data.find((row) => row.card_data.id === el)]))
                }
            })
            Array.from(years).sort().forEach((year) => cols.push({
                name: `${year}`,
                width: '360px',
                cell: (row) => row.map((data) => data.year === year ? <Card data={data.card_data}
                                                                            token={this.props.token}
                                                                            prev={data.prev_year}
                                                                            need_to_change={data.need_to_change}
                                                                            deleteData={() => this.deleteData(data.card_data.id)}
                                                                            checkRowReport={() => this.checkRowReport(data.card_data.id)}
                ></Card> : <></>),
                button: true
            }))
            field_data.push({
                id: i,
                name: field,
                data: rows_data,
                cols: cols,
                expand: this.state.field_data.length!==0?this.state.field_data[i].expand:true
            })

            cols = []
            one_field_data = []
            rows_data = []
        })


        this.setState({
            columns: cols,
            years: years,
            data: data,
            field_data: field_data,
        });
    }

}
